import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import ContractPage from "./ContractPage";

import Header from "./sections/Header";
import HeroSection from "./sections/HeroSection";
import TrustMarquee from "./sections/TrustMarquee";
import ServicesSection from "./sections/ServicesSection";
import KOLSection from "./sections/KOLSection";
import PMSSection from "./sections/PMSSection";
import PricingSection from "./sections/PricingSection";
import TeamSection from "./sections/TeamSection";
import OnboardingFlowSection from "./sections/OnboardingFlowSection";
import SuccessCaseSection from "./sections/SuccessCaseSection";
import CasesSection from "./sections/CasesSection";
import CourseSection from "./sections/CourseSection";
import FooterCTA from "./sections/FooterCTA";
import Footer from "./sections/Footer";

// Home Page Component
const Home = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const sections = document.querySelectorAll("section:not([data-testid='hero-section'])");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
            entry.target.classList.add("reveal-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: "0px 0px -10% 0px" }
    );
    sections.forEach((s) => {
      s.classList.add("reveal");
      observer.observe(s);
    });
    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <TrustMarquee />
      <ServicesSection />
      <KOLSection />
      <PMSSection />
      <SuccessCaseSection />
      <CasesSection />
      <CourseSection />
      <PricingSection />
      <OnboardingFlowSection />
      <TeamSection />
      <FooterCTA />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contract" element={<ContractPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
